<template>
  <el-drawer
    :append-to-body="true"
    :direction="'ltr'"
    :size="'75%'"
    :visible.sync="unfold"
    :with-header="false"
  >
    <div style="background-color: #003333; height: 100%">
      <el-row style="border-bottom: 1px solid #cccccc;">
        <el-col :span="12" class="left-centered">
          <img
            alt="UNIFI Property"
            src="../../../../assets/unifi-logo-new-with-text-white.svg"
            style="width: 150px; height: 41px"
            @click="redirectToHome"
          />
        </el-col>
      </el-row>
      <el-row>
        <li style="background-color: #ffffff">
          <ul v-if="isSignedIn"
              class="sub-menu-item-style sub-item-font"
              style="padding-bottom: 26px"
              @click="logout"
          >
            Logout
          </ul>
        </li>
      </el-row>
      <el-row
        style="background-color: #003333; height: 100%; padding-top: 90px"
      >
        <el-col :sm="6" :span="6" :xs="6" class="centered-social-icon">
          <a href="https://www.facebook.com/unifiproperty" target="_blank">
            <img alt="Facebook" src="../../../../assets/facebook48x48.png"/>
          </a>
        </el-col>
        <el-col :sm="6" :span="6" :xs="6" class="centered-social-icon">
          <a href="https://www.instagram.com/unifiproperty/" target="_blank">
            <img alt="Instagram" src="../../../../assets/instagram48x48.png"/>
          </a>
        </el-col>
      </el-row>
      <el-row></el-row>
    </div>
  </el-drawer>
</template>
<script>

import {mapActions} from "vuex";

export default {
  name:"StepHeaderDrawerAside",
  data() {
    return {
      isSignedIn: false,
    };
  },
  mounted() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },
   props: {
      unfold: Boolean
  },
  created() {
    if(localStorage.getItem("uConnectRegistrationKey")){
      this.isSignedIn = true;
    }
  },
  methods: {
    ...mapActions("uConnect", ["releaseCouponCode"]),
    handleBeforeUnload(event) {
      if (this.$route.path !== "/unifi/register/confirm") {
        event.preventDefault();
        event.returnValue = "Are you sure you want to leave without saving?";
        localStorage.removeItem("uConnectRegistrationKey");
      }
    },

    logout() {

      if (this.$route.path === "/unifi/register/confirm") {
        this.$router.push("/");
        localStorage.removeItem("uConnectRegistrationKey");
      }else {
        this.$confirm('Are you sure you want to sign out? Any data you\'ve entered so far will not be saved.', '', {
          confirmButtonText: 'Confirm', confirmButtonClass: 'confirm-class'
        })
            .then(_ => {
              var that = this;
              localStorage.removeItem("uConnectRegistrationKey");
              if (that.$route.path !== "/") {
                that.$router.push("/");
              } else {
                that.reload();
              }
            })
            .catch(_ => { });
      }

    },
    redirectToHome() {
      //clear search text from session storage

      if (this.$route.path === "/unifi/register/confirm") {
        this.$router.push("/");
        this.clearUserDetails();
      }else {
        this.$emit("unfoldMethod");
        this.$confirm('Are you sure you want to cancel your registration? Any data you\'ve entered so far will not be saved.', '', {
          confirmButtonText: 'Confirm', confirmButtonClass: 'confirm-class', cancelButtonClass: 'cancel-class'
        })
            .then(_ => {
              var that = this;
              localStorage.removeItem("uConnectRegistrationKey");
              if (that.$route.path !== "/") {
                this.$router.push("/");
              } else {
                that.reload();
              }
            })
            .catch(_ => { });
      }
    },
    unfoldMenu() {
      console.log("component called unfoldMenu");
      this.$emit("unfoldMethod");
    },
    clearUserDetails() {
      console.log("clearUserDetails");
      this.handleReleasePromoCode();

      this.$store.commit("uConnect/clearUserDetails");
      localStorage.removeItem("uConnectRegistrationKey");
    },
    async handleReleasePromoCode() {
      console.log("handleReleasePromoCode");
      let uConnectRegistrationKey = localStorage.getItem("uConnectRegistrationKey");
      if (uConnectRegistrationKey) {
        try{
          const params = {
            userId: this.$store.state.uConnect.userId,
            email: this.$store.state.uConnect.email,
            uConnectRegistrationKey: uConnectRegistrationKey
          };
          await this.releaseCouponCode({ params });
        } catch (error) {
          console.error("Failed to release promo code:", error);
        }
      }
    },
  },

  computed: {}
};
</script>

<style scoped>
.main-menu-item-style {
  padding: 30px 40px;
  background-color: #ffffff;
  border-bottom: 1px solid #cccccc;
}

.menu-item-font {
  color: #003333;
  font-feature-settings: "clig" off, "liga" off;
  font-family: DINosaur-a;
  font-size: 28px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.sub-menu-item-style {
  padding: 0 40px;
  background: #ffffff;
}

.sub-item-font {
  color: #003333;
  font-feature-settings: "clig" off, "liga" off;
  font-family: DINosaur-a;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.centered-social-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}

.left-centered {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 20px 0 20px 40px;
}

.right-centered {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 20px 16px 20px 0;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .menu-item-font {
    font-size: 22px;
  }

  .sub-item-font {

    font-size: 16px;
  }

}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {

}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {

}


</style>



// WEBPACK FOOTER //
// src/components/register/uConnectRegistration/steps/stepsHeaderDrawerAside.vue